<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="grid_row" v-else>
      <v-form ref="update_pr" @submit.prevent="update_pr">
        <v-card elevation="6">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
            <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="grid_half">
            <div class="grid_list pa-4">
              <div class="mr-1">
                <div class="mb-2">เพิ่มสินค้าเข้าคลังด้วยใบเสร็จ</div>
                <v-text-field color="#86bc3a" label="เลขที่ใบเสร็จ" prepend-inner-icon="mdi-file-compare"
                  :rules="[v => !!v || 'กรุณากรอกเลขที่ใบเสร็จ']" v-model="header_list.receipt_no" hide-details="auto"
                  outlined></v-text-field>
              </div>
              <div class="mr-1">
                <div>ชื่อ บริษัท/Supplier Name</div>
                <div class="pl-3 pt-5 grey--text">{{ header_list.supplier_name }}</div>
              </div>
              <div class="mt-3">
                <div class="mr-1">
                  <div class="mb-2">วันที่ใบเสร็จ (วัน/เดือน/ปี)</div>
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="date" :rules="[v => !!v || 'กรุณากรอกวันที่ใบเสร็จ']"
                        label="วันที่ใบเสร็จ (วัน/เดือน/ปี)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDateTH(dateEN)" :max="start_date"
                      v-model="dateEN" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div class="ma-4">
              <div class="grid_vat">
                <div class="ml-1">
                  <div>ภาษีการซื้อ :</div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="header_list.vat_type" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex ml-5">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ภาษีรวมใน</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>ภาษีแยกนอก</div>
                      </div>
                    </div>
                    <div class="d-flex justify-space-around mt-6">
                      <div class="d-flex" style="margin-left: 3px">
                        <div>
                          <v-radio color="#86bc3a" :value="2"></v-radio>
                        </div>
                        <div>ไม่กระทบภาษี</div>
                      </div>
                      <div class="d-flex ml-n12">
                        <div>
                          <v-radio color="#86bc3a" :value="3"></v-radio>
                        </div>
                        <div>ภาษีเป็น 0</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="grid_half">
            <div v-if="header_list.is_credit === 1">
              <div class="grid_list pa-4">
                <div class="mr-1">
                  <div class="mb-2">วันที่ครบกำหนด (วัน/เดือน/ปี)</div>
                  <v-menu ref="menu_due_date" v-model="menu_due_date" :close-on-content-click="false"
                    :return-value.sync="dateDue" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="dateDue" :rules="[v => !!v || 'กรุณากรอกวันที่ครบกำหนด']"
                        label="วันที่ครบกำหนด (วัน/เดือน/ปี)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDueDateTH(dateDueEN)" v-model="dateDueEN"
                      no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDueDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_due_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div v-else></div>
            <div class="ma-4">
              <div class="grid_vat">
                <div class="ml-1">
                  <div>ประเภท :</div>
                  <div class="mt-3 mr-1">
                    <v-radio-group v-model="header_list.is_credit" mandatory>
                      <div class="d-flex justify-space-around">
                        <div class="d-flex ml-n4">
                          <div>
                            <v-radio color="#86bc3a" :value="0"></v-radio>
                          </div>
                          <div>เงินสด</div>
                        </div>
                        <div class="d-flex ml-n12">
                          <div>
                            <v-radio color="#86bc3a" :value="1"></v-radio>
                          </div>
                          <div>เครดิต</div>
                        </div>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid_full pl-4 pt-4 pr-4">
            <div style="display: flex; !important;">
              <v-autocomplete clearable color="#86bc3a" :items="product_list" item-text="product_name"
                item-value="product_id" @input="add_product(pro_id)" v-model="pro_id"
                prepend-inner-icon="mdi-flask-plus-outline" label="สินค้า" hide-details="auto" outlined />
            </div>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table class="mb-2" :headers="Pr_List" :items="data_list" key="index" item-key="product_code"
            :search="search" mobile-breakpoint="0" hide-default-footer :items-per-page="100">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td class="pa-3">
                  <v-text-field color="#86bc3a" label="ล็อต" :rules="[v => !!v || 'กรุณากรอกล็อต']" hide-details="auto"
                    v-model="dataDetail.item.lot_no" outlined></v-text-field>
                </td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>
                  <v-select v-if="dataDetail.item.id === null" color="#86bc3a" :items="dataDetail.item.unit_choices"
                    placeholder="กรุณาเลือก" :rules="[v => !!v || 'กรุณาเลือก']" item-text="unit_name" @change="getUnitQty(dataDetail.index, dataDetail.item.unit_id)"
                    item-value="unit_id" hide-details="auto" v-model="dataDetail.item.unit_id" outlined />
                  <div v-else>{{ dataDetail.item.unit }}</div>
                </td>
                <td>
                  <date-picker clearable class="input_style" :disabled-date="notBeforeToday" value-type="format"
                    :formatter="format" v-model="dataDetail.item.date_expired"
                    :placeholder="dataDetail.item.date_expired" />
                </td>
                <td>
                  <v-text-field v-if="dataDetail.item.id === null" color="#86bc3a" type="number"
                    @keypress="isOnlyNumber($event)" label="จำนวนที่ได้รับ"
                    :rules="[v => !!v || 'กรุณากรอกจำนวนที่ได้รับ']" hide-details="auto" min="0"
                    v-model="dataDetail.item.quantity" outlined></v-text-field>
                  <div v-else class="text-center">{{ dataDetail.item.quantity }}</div>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number" @keypress="isCurrency($event, dataDetail.item.price)"
                    label="ราคาต่อหน่วย" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" hide-details="auto" min="0"
                    v-model="dataDetail.item.price" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    @keypress="isCurrency($event, dataDetail.item.discount_unit)" label="ส่วนลด(บาท)" hide-details="auto"
                    min="0" v-model="dataDetail.item.discount_unit" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field color="#86bc3a" type="number"
                    @keypress="isCurrency($event, dataDetail.item.discount_percent)" label="ส่วนลด(%)" hide-details="auto"
                    min="0" v-model="dataDetail.item.discount_percent" outlined></v-text-field>
                </td>
                <td>{{ format_price(dataDetail.item.total = (((dataDetail.item.price) - ((dataDetail.item.price *
                  dataDetail.item.discount_percent) / 100)) * dataDetail.item.quantity) - dataDetail.item.discount_unit)
                }}</td>

                <td>
                  <!-- ค่าเก่าที่มีอยู่แล้ว -->
                  <div v-if="dataDetail.item.exchange_status_old == 1 && dataDetail.item.exchange_status == 0">-</div>
                  <div v-if="dataDetail.item.exchange_status_old == 1 && dataDetail.item.exchange_status == 1">รอคืน
                  </div>
                  <!-- ค่าใหม่ที่พึ่งมา -->
                  <div v-if="dataDetail.item.exchange_status_old == 0">
                    <v-checkbox color="#86bc3a" v-model="dataDetail.item.exchange_status" />
                  </div>
                </td>
                <td class="pa-3">
                  <div class="text-center" v-if="dataDetail.item.id !== null">-</div>
                  <v-btn v-else small height="42" @click="getDelete(dataDetail.item.loop_id)"
                    class="grad-danger-bg white--text mb-1">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="9" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">รวม</div>
                  </div>
                </td>
                <td colspan="4" class="pa-2 border_col text-center">
                  <div class="ma-4">
                    <div class="text-center">{{ header_list.sub_total = total }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class=" ma-4">
                    <div>ส่วนลดท้ายบิล (%)</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" type="number" label="ส่วนลดท้ายบิล (%)"
                        @keypress="isCurrency($event, header_list.discount_percent)" hide-details="auto" min="0"
                        v-model="header_list.discount_percent" outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class=" ma-4">
                    <div>ส่วนลดท้ายบิล (หน่วย)</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>
                      <v-text-field color="#86bc3a" type="number" label="ส่วนลดท้ายบิล (หน่วย)"
                        @keypress="isCurrency($event, header_list.discount)" hide-details="auto" min="0"
                        v-model="header_list.discount" outlined></v-text-field>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="border_col">
                  <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                  <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ product_no_vat = no_vat }}</div>
                  <v-divider />
                  <div class="ma-4 text-center">{{ product_add_vat = cal_vat }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <!-- <div class="text-center">{{ format_price(header_list.total = (total_all - header_list.discount)) }}</div> -->
                    <div class="text-center">{{ header_list.total = total_all }}</div>
                  </div>
                </td>
              </tr>
              <v-divider />
            </template>
          </v-data-table>
          <div class="pa-4">
            <div class="mb-4">
              หมายเหตุ
            </div>
            <v-textarea v-if="header_list.note != null" color="#86bc3a" label="กรุณากรอกหมายเหตุ"
              v-model="header_list.note" outlined></v-textarea>
            <v-textarea v-if="header_list.note == null" color="#86bc3a" label="กรุณากรอกหมายเหตุ" value="-" v-model="header_list.note"
              outlined></v-textarea>
          </div>
          <div class="pa-6 text-right">
            <v-btn x-large type="submit" class="grad-warning-bg white--text" style="font-size: 18px">แก้ไขข้อมูล</v-btn>
          </div>
        </v-card>
      </v-form>
    </div>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { diffChangeFormat_2, formatPrice, minDate, onlyForCurrency, onlyForNumber } from "@/js/handler";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import { log } from "console";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    DatePicker
  },
  name: "StoragePR_edit",
  data() {
    return {
      search: '',
      loading_page: false,
      overlay: false,
      alert_success: false,
      alert_danger: false,
      start_date: this.min_date(),
      menu_date: false,
      menu_due_date: false,
      exchange_status: false,
      format: {
        stringify: (date) => {
          const date_moment = moment(date).format('DD-MM-YYYY')
          const diff = date_moment.split('-')
          const day = diff[0]
          const month = diff[1]
          // const year = parseInt(diff[2]) + 543
          const year = parseInt(diff[2])
          return day + '-' + month + '-' + year
        },
      },
      date: '',
      dateEN: '',
      dateDue: '',
      dateDueEN: '',
      Pr_List: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '95px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_choices',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '95px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สินค้ารอคืน',
          value: 'exchange_status',
          sortable: false,
          fixed: true,
          width: '125px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '50px',
        },
      ],
      header_list: [],
      data_list: [],
      product_list: [],
      unit_list: [],
      loop_id: 0,
      pro_id: null,
      product_no_vat: '0',
      product_add_vat: '0',
      // test:[]
    }
  },
  methods: {
     getUnitQty(index, id){
      this.data_list[index].unit_qty = this.data_list[index].unit_choices.find(o => o.unit_id === id).unit_qty
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    async selectDueDate() {
      this.$refs.menu_due_date.save(this.dateDue)
      this.menu_due_date = false
    },
    date_table(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])
        return day + '-' + month + '-' + year
      }
      else {
        value = ''
        return value
      }
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '-' + month + '-' + year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    diffDueDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '-' + month + '-' + year
      return this.dateDue = final_date
    },
    diffDueDateEN() {
      const diff = this.dateDue.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    min_date: function () {
      return minDate()
    },
    diffDate_Change_2: function (value) {
      return diffChangeFormat_2(value)
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    get_data() {
      this.data_list = []
      this.loading_page = true
      HTTP.post('/imports/pr/editpr', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.pr_head
          // console.log(res.data);
          if (res.data.pr_head.receipt_date !== null) {
            this.date = res.data.pr_head.receipt_date
            this.diffDateTH(this.date)
          }
          else {
            this.date = ''
          }
          if (res.data.pr_head.credit_date !== null) {
            this.dateDue = res.data.pr_head.credit_date
            this.diffDueDateTH(this.dateDue)
          }
          else {
            this.dateDue = ''
          }
          this.product_list = res.data.products
          res.data.pr_lists.forEach((data) => {
            const id = this.loop_id += 1;

            this.data_list.push({
              loop_id: id,
              id: data.id,
              cost: data.cost,
              date_expired: data.date_expired,
              discount_percent: data.discount_percent,
              discount_price: data.discount_price,
              discount_unit: data.discount_unit,
              exchange_status_old: 1,
              exchange_status: data.exchange_status,
              import_id: data.import_id,
              importlist_id: data.importlist_id,
              lot_no: data.lot_no,
              price: data.price,
              product_code: data.product_code,
              product_id: data.product_id,
              product_name: data.product_name,
              quantity: data.quantity,
              status: data.status,
              supplier: data.supplier,
              unit: data.unit,
              unit_choices: data.unit_choices,
              unit_id: data.unit_id,
              unit_qty: data.unit_qty,
              total: data.total,
            })
            
          })
        }
      })
    },
    async add_product(pro_id) {
      await HTTP.post('/imports/pr/units', {
        product_id: pro_id
      }).then((res) => {

        if (res.data.success === true) {
          this.alert_success = true;
          this.unit_list = res.data.object
          // console.log(res.data.object);
        }
      })
      let value = this.product_list.filter((res) => {
        return res.product_id === pro_id
      });
      value.forEach((data) => {
        const id = this.loop_id += 1;
        this.data_list.push({
          loop_id: id,
          id: null,
          cost: 0,

          date_expired: this.min_date(),
          discount_percent: null,
          discount_price: null,
          discount_unit: null,
          exchange_status_old: 0,
          exchange_status: 0,
          import_id: null,
          importlist_id: null,
          lot_no: null,
          price: null,
          total: 0,
          product_code: data.product_code,
          product_id: data.product_id,
          product_name: data.product_name,
          quantity: null,
          quantity_total: 0,
          supplier: null,
          unit: null,
          unit_choices: this.unit_list,
          unit_id: data.unit_id,
          unit_qty: 1,
        })
      })
      await this.$nextTick(() => {
        this.pro_id = null;
        setTimeout(() => this.alert_success = false, 3000);
      })
    },
   async update_pr() {
      let check_date_expired = false
      this.data_list.forEach((datalist, index) => {
        if (this.data_list[index].date_expired == null || this.data_list[index].date_expired == '') {
          check_date_expired = true
          return
        }
      });
      if (this.$refs.update_pr.validate()) {

        this.data_list.forEach((datalist, index) => {
          // alert(datalist.quantity)
          this.data_list[index].quantity_total = parseInt(datalist.unit_qty) * parseInt(datalist.quantity)
          this.data_list[index].cost = (parseFloat(datalist.total)  / (parseInt(datalist.unit_qty) * parseInt(datalist.quantity)))



          // this.data_list[index].cost = datalist.total / datalist.quantity;
          this.data_list[index].exchange_status = this.data_list[index].exchange_status == 0 || this.data_list[index].exchange_status == false ? 0 : 1;

        })
        let qty_arr = []
        let total_arr = []
        let product_id = []
        let checkcost = {}
        this.data_list.forEach(async (items) => {
          let item = null
          let check_product_id = await product_id.find(o => o == items.product_id)
          if (check_product_id == null) {
            product_id.push(items.product_id)
            total_arr.push({id:items.product_id, total: 0})
            qty_arr.push({id:items.product_id, qty: 0})
          }
          item = items.unit_choices.find((detail) => {
            return items.unit_id == detail.unit_id;
          });

           let qtyObj = qty_arr.find(o => o.id === items.product_id);
            if(qtyObj){
              qtyObj.qty += parseInt(items.quantity * item.unit_qty)
            }
              let totalObj = total_arr.find(o => o.id === items.product_id);
            if(totalObj){
             totalObj.total += parseFloat(items.total)
            }
          checkcost = this.data_list.filter((res) => res.product_id === items.product_id)
          checkcost.forEach((details) => {
            details.cost = totalObj.total / qtyObj.qty
          });
        })
          // console.log(data_array);

        if (check_date_expired === true) {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'เนื่องจาก ไม่ได้กรอกวันหมดอายุของสินค้า !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          });
        }

       let data = {
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            id: this.header_list.id,
            supplier_name: this.header_list.supplier_name,
            product_no_vat: parseFloat(this.product_no_vat.replace(/,/g, '')),
            product_add_vat: parseFloat(this.product_add_vat.replace(/,/g, '')),
            discount_percent: parseFloat(this.header_list.discount_percent.replace(/,/g, '')),
            discount: this.header_list.discount,
            exchange_status: this.exchange_status,
            total: parseFloat(this.header_list.total.replace(/,/g, '')),
            receipt_date: this.diffDateEN(),
            credit_date: this.diffDueDateEN(),
            receipt_no: this.header_list.receipt_no,
            is_credit: this.header_list.is_credit,
            vat_type: this.header_list.vat_type,
            note: this.header_list.note,
            data_list: await this.data_list,
          }

        if (check_date_expired === false) {
          this.overlay = true
          this.test = this.data_list
          HTTP.post('/imports/pr/update', data).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              Swal.fire('แก้ไขข้อมูลเรียบร้อย', '', 'success')
                .then(() => {
                  this.$router.push('/stock/storage/addproducttostock');
                });
            }
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'เนื่องจาก ไม่มีข้อมูลหรือกรอกข้อมูลไม่ครบ !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getDelete(loop_id) {
      Swal.fire({
        text: 'ต้องการลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_danger = true;
          setTimeout(() => this.alert_danger = false, 3000);
          this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
        }
      })
    }
  },
  computed: {
    total() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum, number) => {
      //   let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //   if (total_price < 0) {
      //     return sum+(0);
      //   }
      //   else {
      //     return sum+(total_price);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.vat_type === 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     let in_vat = ((total_price * 7)/107);
      //     let total_grand = total_price - in_vat
      //     if (total_grand < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+(total_grand);
      //     }
      //   }
      //   else if(this.header_list.vat_type === 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.header_list.vat_type === 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      //   else if(this.header_list.vat_type === 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0);
      //     }
      //     else {
      //       return sum+((total_price));
      //     }
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.header_list.vat_type == 0) {
        let before_vat = total_discount * (100 / 107);
        return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    cal_vat() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.vat_type === 0) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     let calculate = ((total_price * 7)/107);
      //     return sum+(calculate);
      //   }
      //   else if (this.header_list.vat_type === 1){
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     let calculate = (total_price * (7/100));
      //     return sum+(calculate);
      //   }
      //   else if (this.header_list.vat_type === 2){
      //     return sum+(0);
      //   }
      //   else if (this.header_list.vat_type === 3){
      //     return sum+(0);
      //   }
      // }, 0)
      // return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      let total_discount = total_percent - discount_unit;

      if (this.header_list.vat_type == 0) {
        let result_vat = total_discount * (7 / 107);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (this.header_list.vat_type == 1) {
        let result_vat = total_discount * (7 / 100);
        return result_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        let zero = 0
        return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    total_all() {
      // let data_list = this.data_list;
      // const result = data_list.reduce((sum,number) => {
      //   if (this.header_list.vat_type === 0){
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.header_list.vat_type === 1) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     let ex_vat = ((total_price * 7)/100);
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price + ex_vat);
      //     }
      //   }
      //   else if(this.header_list.vat_type === 2) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      //   else if(this.header_list.vat_type === 3) {
      //     let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
      //     if (total_price < 0) {
      //       return sum+(0)
      //     }
      //     else {
      //       return sum+(total_price);
      //     }
      //   }
      // }, 0)
      // return result;
      let result_vat = 0;
      let total_discount = 0;
      let discount_percent = this.header_list.discount_percent;
      let discount_unit = this.header_list.discount;
      let data_list = this.data_list;
      const subTotal = data_list.reduce((sum, number) => {
        return sum + number.total
      }, 0);

      let percent = (parseFloat(subTotal) * discount_percent) / 100;
      let total_percent = parseFloat(subTotal) - percent;
      if (this.header_list.vat_type == 1) {
        result_vat = total_percent - discount_unit;
        total_discount = result_vat * (7 / 100) + (result_vat);
      } else {
        total_discount = total_percent - discount_unit;
      }
      return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.grid_row {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}

.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_product {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}

.input_style>>>input {
  border: #9e9e9e solid 1px !important;
  transition: 0.2s !important;
  font-size: 18px !important;
  color: black !important;
  padding: 27px !important;
  padding-left: 12px !important;
}

.input_style>>>input:hover {
  border-color: black !important;
}

.input_style>>>input:focus {
  border-color: #8cc63e !important;
}

@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_product {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
